var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen font-app",attrs:{"id":"app"}},[_c('header-chart-component'),_c('header-component'),_c('router-view'),_c('footer-component',{on:{"updateData":_vm.fetchAPI}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }